import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

interface RoundedButtonProps {
  title: string;
  onClick?: () => void;
}

export default function RoundedButton({ title, onClick }: RoundedButtonProps) {
  return (
    <Button
      onClick={onClick}
      sx={{
        display: "flex",
        color: "#000",
        backgroundColor: "#FEB533",
        borderRadius: "20px",
        transition: "all 0.2s ease",
        fontWeight: "bold",
        cursor: "pointer",
        alignItems: "center",
        border: "none",
        px: 2,
        textTransform: "none",
        "&:hover": {
          backgroundColor: "#fff",
          color: "#000",
          "& .arrow": {
            transform: "rotate(-45deg) translate(4px, 4px)",
            borderColor: "#000",
          },
          "& .arrow::before": {
            opacity: 1,
            width: "9px",
          },
        },
      }}
    >
      {title}
      <Box
        className="arrow"
        sx={{
          width: "7px",
          height: "7px",
          borderRight: `2px solid #000`,
          borderBottom: `2px solid #000`,
          position: "relative",
          transform: "rotate(-45deg)",
          margin: "1px 6px 0 6px",
          transition: "all 0.2s ease",
          "&::before": {
            display: "block",
            backgroundColor: "currentColor",
            width: "3.5px",
            height: "2px",
            position: "absolute",
            opacity: 0,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%) rotate(45deg)",
            transition: "all 0.3s ease",
            content: '""',
            transformOrigin: "center",
          },
        }}
      />
    </Button>
  );
}
